/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-expressions */
import angular from 'angular';
import {
  AccountIntegrityChallengeService,
  AccountRecoveryModalService,
  CrossDeviceLoginDisplayCodeService,
  EnvironmentUrls,
  FormEvents,
  UrlParser
} from 'Roblox';
import loginModule from '../loginModule';

const { SecurityQuestions, TwoStepVerification } = AccountIntegrityChallengeService;

function loginFormController(
  $scope,
  $injector,
  $window,
  $timeout,
  $httpParamSerializerJQLike,
  $uibModal,
  urlService,
  phoneService,
  languageResource,
  loginService,
  captchaV2Constants,
  loginConstants,
  urlConstants,
  systemFeedbackService,
  localStorageService
) {
  'ngInject';

  $scope.loginFormData = {
    forgotCredentialsUrl: EnvironmentUrls.websiteUrl + loginConstants.urls.forgotCredentials,
    homeUrl: EnvironmentUrls.websiteUrl + loginConstants.urls.home,
    loginPageUrl: EnvironmentUrls.websiteUrl + loginConstants.urls.login,
    securityNotificationUrl: EnvironmentUrls.websiteUrl + loginConstants.urls.securityNotification,
    redirectToFb: EnvironmentUrls.websiteUrl + loginConstants.urls.redirectToFb
  };
  $scope.loginLayout = {
    isFirstSubmit: true
  };
  $scope.forms = {};
  $scope.loginParams = $scope.loginParams || {};
  $scope.crossDeviceLoginParams = {};
  $scope.funCaptchaSetting = {};
  $scope.accountRecoveryLoginFailureCount = 0;

  $scope.loginCaptchaActivated = false;
  $scope.captchaActionTypes = captchaV2Constants.captchaActionTypes;
  $scope.captchaExtraValidationParams = {};

  $scope.isAccountRecoveryPromptEnabled = false;

  $scope.securityQuestionParameter = null;

  $scope.numberOfFailedTwoStepVerificationChallengeAttempts = 0;
  $scope.identityVerificationLoginTicket = null;

  const watchParams = $scope.$watch(
    function () {
      return $scope.loginParams;
    },
    function (newValue) {
      if (newValue) {
        const errorCode = $scope.getUrlParamValue(loginConstants.urlQueryNames.errorCode);

        if (errorCode && !$scope.loginParams.redirectToLoginPageOnError) {
          const ctype = $scope.getUrlParamValue(loginConstants.urlQueryNames.cType);

          $scope.loginFormData.credentialValue = $scope.getUrlParamValue(
            loginConstants.urlQueryNames.username
          );
          $scope.setEnteredCredentialType(ctype);
          $scope.loginLayout.error = $scope.getErrorMessage(parseInt(errorCode, 10));
        } else {
          $scope.loginFormData.credentialValue = null;
        }
      }
    },
    true
  );

  window.addEventListener(
    'OnCrossDeviceCodeValidated',
    event => {
      $scope.crossDeviceLoginParams.code = event.detail.code;
      $scope.crossDeviceLoginParams.enteredCredentialType = event.detail.ctype;
      $scope.crossDeviceLoginParams.privateKey = event.detail.privateKey;
      $scope.setEnteredCredentialType(event.detail.ctype);
      $scope.loginLayout.isProcessing = true;
      $scope.login();
    },
    false
  );

  $scope.getUrlParamValue = function (name) {
    if (!UrlParser) {
      return null;
    }

    const result = UrlParser.getParameterValueByName(name);

    return result ? encodeURIComponent(result) : result;
  };

  $scope.$on('$destroy', function () {
    watchParams();
  });

  // eslint-disable-next-line no-unused-vars
  $scope.init = function (captchaId) {
    loginService.getAuthTokenMetadata().then(function (data) {
      $scope.crossDeviceLoginParams.IsLoginCodeButtonDisplayed = data?.IsLoginCodeButtonDisplayed;
    });

    loginService.getMetadataV2().then(function (data) {
      $scope.isAccountRecoveryPromptEnabled = data?.IsAccountRecoveryPromptEnabled;
      $scope.isLoginTwoStepVerificationModalEnabled = data?.IsLoginTwoStepVerificationModalEnabled;
    });

    $scope.loginLayout.isProcessing = false;
  };

  $scope.handleCaptchaError = function (errorCode) {
    const loginErrorCode = $scope.getLoginErrorCodeFromCaptchaErrorCode(errorCode);

    $timeout(function () {
      $scope.loginLayout.isProcessing = false;
      $scope.setErrorMessage(loginErrorCode, true);
    });
  };

  $scope.handleCaptchaSuccess = function (captchaData) {
    $scope.loginLayout.forceCaptcha = false;
    const isCrossDeviceLogin =
      $scope.loginFormData.enteredCredentialType === loginConstants.credentialTypes.authToken;
    if (isCrossDeviceLogin) {
      $scope.login(captchaData);
    } else {
      $scope.submit(false, captchaData);
    }
  };

  $scope.getLoginErrorCodeFromCaptchaErrorCode = function (captchaErrorCode) {
    switch (captchaErrorCode) {
      case captchaV2Constants.errorCodes.internal.failedToLoadProviderScript:
        return loginConstants.errorCodes.captchaLoadFailed;
      case captchaV2Constants.errorCodes.internal.failedToVerify:
        return loginConstants.errorCodes.captchaVerifyFailed;
      default:
        return loginConstants.errorCodes.captchaUnknownError;
    }
  };

  $scope.setEnteredCredentialType = function (credentialType) {
    if (credentialType) {
      $scope.loginFormData.enteredCredentialType = credentialType;
      return;
    }

    if ($scope.isEmail($scope.loginFormData.credentialValue)) {
      $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.email;
      return;
    }

    if (phoneService.isPhoneNumber($scope.loginFormData.credentialValue)) {
      $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.phone;
      return;
    }

    $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.username;
  };

  $scope.login = function (captchaData) {
    const didUserEnterEmail = $scope.isEmail($scope.loginFormData.credentialValue);
    const didUserEnterPhone = phoneService.isPhoneNumber($scope.loginFormData.credentialValue);

    if (!$scope.loginFormData.isDefaultLoginRequired) {
      // if user entered in text containing "@", assume they are trying to log in with email
      if (didUserEnterEmail) {
        $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.email;
      } else if (didUserEnterPhone) {
        $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.phone;
      }
    }

    // remove the error banner if they are now trying to log in with username
    if (!didUserEnterEmail && !didUserEnterPhone) {
      systemFeedbackService.clear();
    }
    const isCrossDeviceLogin =
      $scope.loginFormData.enteredCredentialType === loginConstants.credentialTypes.authToken;

    // update login params based on ctype.
    const cvalue = isCrossDeviceLogin
      ? $scope.crossDeviceLoginParams.code
      : $scope.loginFormData.credentialValue;
    const ctype = isCrossDeviceLogin
      ? $scope.crossDeviceLoginParams.enteredCredentialType
      : $scope.loginFormData.enteredCredentialType;
    const password = isCrossDeviceLogin
      ? $scope.crossDeviceLoginParams.privateKey
      : $scope.loginFormData.password;

    const loginParams = {
      cvalue,
      ctype,
      password
    };

    if (captchaData != null) {
      loginParams.captchaId = captchaData.captchaId;
      loginParams.captchaToken = captchaData.captchaToken;
      loginParams.captchaProvider = captchaData.captchaProvider;
    }

    if ($scope.securityQuestionParameter !== null) {
      loginParams.securityQuestionSessionId = $scope.securityQuestionParameter.sessionId;
      loginParams.securityQuestionRedemptionToken =
        $scope.securityQuestionParameter.redemptionToken;
    }

    loginService.login(loginParams).then(
      function (response) {
        $scope.incrementEphemeralCounter(loginConstants.counters.success);
        const { data } = response;
        if ($scope.isLoginTwoStepVerificationModalEnabled) {
          let twoStepVerificationToken;

          if (data && data.tl) {
            twoStepVerificationToken = data.tl;
          } else if (data && data.twoStepVerificationData) {
            twoStepVerificationToken = data.twoStepVerificationData.ticket
          }

          if (data && data.identityVerificationLoginTicket) {
            $scope.identityVerificationLoginTicket = data.identityVerificationLoginTicket;
          }

          if (twoStepVerificationToken) {
            $scope.userId = data.user.id;
            $scope.challengeId = twoStepVerificationToken;
            $scope.renderTwoStepVerificationChallenge();
          } else {
            $window.location.href = $scope.getRedirectUrl(data);
          }
        }
        else {
          $window.location.href = $scope.getRedirectUrl(data);
        }
      },
      function (result) {
        $scope.handleLoginError(result.data, result.status);
      }
    );
  };

  $scope.renderTwoStepVerificationChallenge = () => {
    TwoStepVerification.renderChallenge({
      containerId: '2sv-popup-container',
      userId: $scope.userId,
      challengeId: $scope.challengeId,
      actionType: TwoStepVerification.ActionType.Login,
      renderInline: false,
      shouldShowRememberDeviceCheckbox: true,
      shouldDynamicallyLoadTranslationResources: false,
      onChallengeCompleted: $scope.receiveTwoStepChallengeToken,
      onChallengeInvalidated: $scope.handleInvalidatedTwoStepVerificationChallenge,
      onModalChallengeAbandoned: () => {
        $timeout(function () {
          $scope.loginLayout.isProcessing = false;
        });
      }
    }).then(success => {
      if (!success) {
        $scope.loginLayout.error = languageResource.get('Message.UnknownErrorTryAgain');
      }
    }).catch(() => {
      $scope.loginLayout.error = languageResource.get('Message.UnknownErrorTryAgain');
   })
  };

  $scope.handleInvalidatedTwoStepVerificationChallenge = () => {
    $scope.numberOfFailedTwoStepVerificationChallengeAttempts += 1;
    $scope.loginLayout.error = languageResource.get('Response.VerificationError');
    if ($scope.numberOfFailedTwoStepVerificationChallengeAttempts < loginConstants.retryAttempts.maxInvalidatedChallengeAttempts) {
      $scope.login();
    } else {
      $scope.loginLayout.error = languageResource.get('Response.VerificationError');
    }
  };

  $scope.receiveTwoStepChallengeToken = tokenData => {
    loginService.loginWithVerificationToken($scope.userId, $scope.challengeId, tokenData.verificationToken, tokenData.rememberDevice)
      .then(response => {
        if (response) {
          $scope.twoStepVerificationReturnUrl = urlService.getAbsoluteUrl('/');
          if (response.identityVerificationLoginTicket) {
            localStorageService.setLocalStorage(
              'identityVerificationLoginTicket',
              response.identityVerificationLoginTicket
            );
            $scope.twoStepVerificationReturnUrl = urlService.getAbsoluteUrl(loginConstants.urls.koreaIdVerification);
          } else if ($scope.loginParams.returnUrl) {
            $scope.twoStepVerificationReturnUrl = $scope.loginParams.returnUrl;
          } else if (!$scope.loginParams.redirectToHomePostLogin) {
            $scope.twoStepVerificationReturnUrl = $scope.getCurrentLocation();
          }
          $window.location.href = $scope.twoStepVerificationReturnUrl;
        } else {
          $scope.loginLayout.error = languageResource.get('Response.VerificationError');
        }
      })
      .catch(() => {
        $scope.loginLayout.error = languageResource.get('Message.UnknownErrorTryAgain');
      });
  };
    
  $scope.handleLoginError = function (result, status) {
    if (status === loginConstants.statusCodes.flooded) {
      $scope.setErrorMessage(loginConstants.errorCodes.tooManyAttempts, true);
      return;
    }
    const errorCode = result && result.errors && result.errors.length > 0 && result.errors[0].code;

    // eslint-disable-next-line default-case
    switch (errorCode) {
      case loginConstants.errorCodes.captcha:
        let dxBlob = '';
        let captchaId = '';
        if (result.errors && result.errors.length > 0 && result.errors[0].fieldData) {
          const captchaData = result.errors[0].fieldData;
          let jsonData = '';
          if (captchaData != null) {
            try {
              jsonData = JSON.parse(captchaData);
              dxBlob = jsonData.dxBlob;
              captchaId = jsonData.unifiedCaptchaId;
            } catch (e) {
              // backward compatible with old version that returns string only.
              dxBlob = captchaData;
            }
          }
        }
        $scope.inputParams = { unifiedCaptchaId: captchaId, dataExchange: dxBlob };
        $scope.activateCaptcha(true);
        $scope.loginLayout.isProcessing = false;
        $scope.incrementEphemeralCounter(loginConstants.counters.captcha);
        return;
      case loginConstants.errorCodes.passwordResetRequired:
        $scope.incrementEphemeralCounter(loginConstants.counters.passwordResetRequired);
        $scope.navigateToSecurityNotificationPage();
        return;
      case loginConstants.errorCodes.securityQuestionRequired:
        $scope.incrementEphemeralCounter(loginConstants.counters.securityQuestionRequired);
        let userId = '';
        let sessionId = '';
        if (result.errors && result.errors.length > 0 && result.errors[0].fieldData) {
          const securityQuestionResultData = result.errors[0].fieldData;
          let jsonData = '';
          if (securityQuestionResultData != null) {
            try {
              jsonData = JSON.parse(securityQuestionResultData);
              userId = jsonData.userId;
              sessionId = jsonData.sessionId;
            } catch (e) {
              // No-op.
            }
          }
        }
        // Not expected to happen if we get this error code.
        if (userId === '' || sessionId === '') {
          $scope.loginLayout.isProcessing = false;
          $scope.loginLayout.error = languageResource.get('Message.UnknownErrorTryAgain');
          return;
        }
        $scope.launchSecurityQuestionsModal(userId, sessionId);
        return;
      case loginConstants.errorCodes.badCredentials:
        // only reached after solving captcha as error code will be captcha otherwise
        if ($scope.isAccountRecoveryPromptEnabled) {
          $scope.accountRecoveryLoginFailureCount += 1;
          $scope.launchAccountRecoveryModal();
        }
    }

    if (
      errorCode === loginConstants.errorCodes.unverifiedCredentials &&
      $scope.loginFormData.enteredCredentialType === loginConstants.credentialTypes.email
    ) {
      $scope.incrementEphemeralCounter(loginConstants.counters.unverifiedAccount);

      const canVerifyCredentialsParams = {
        credentialType: loginConstants.credentialTypes.email,
        credentialValue: $scope.loginFormData.credentialValue,
        password: $scope.loginFormData.password
      };

      loginService.canVerifyCredentials(canVerifyCredentialsParams).then(
        function (response) {
          if (response && response.data && response.data.canSend) {
            $scope.promptUserToVerifyEmail();
            $scope.loginLayout.isProcessing = false;
          } else {
            $scope.setErrorMessage(errorCode);
          }
        },
        function () {
          $scope.setErrorMessage(errorCode);
        }
      );
    } else {
      $scope.setErrorMessage(errorCode, true);
    }
  };

  $scope.promptUserToVerifyEmail = function () {
    $uibModal
      .open({
        backdrop: 'static',
        templateUrl: loginConstants.templates.verifyEmail,
        controller: loginConstants.controllers.verifyEmail,
        resolve: {
          injectedData: {
            context: $scope.loginParams.context,
            email: $scope.loginFormData.credentialValue,
            password: $scope.loginFormData.password
          }
        }
      })
      .result.then(angular.noop, angular.noop);
  };

  $scope.setErrorMessage = function (errorCode, incrementFailureCounter) {
    const usernameLoginRequired =
      errorCode === loginConstants.errorCodes.defaultLoginRequired ||
      errorCode === loginConstants.errorCodes.unverifiedCredentials;

    if (
      $scope.loginParams.redirectToLoginPageOnError ||
      ($scope.loginParams.redirectToLoginPageWhenUsernameIsRequired && usernameLoginRequired)
    ) {
      const params = {
        errorCode,
        ctype: $scope.loginFormData.enteredCredentialType
      };

      if (!usernameLoginRequired) {
        params.username = $scope.loginFormData.credentialValue;
      }

      $scope.incrementEphemeralCounter(loginConstants.counters.redirectToLogin);
      $window.location.href =
        $scope.loginFormData.loginPageUrl +
        urlConstants.urlQueryStringPrefix +
        $httpParamSerializerJQLike(params);
      return;
    }

    $scope.loginLayout.isProcessing = false;
    $scope.loginLayout.error = $scope.getErrorMessage(errorCode, incrementFailureCounter);
  };

  $scope.getErrorMessage = function (errorCode, incrementFailureCounter) {
    switch (errorCode) {
      case loginConstants.errorCodes.badCredentials:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.invalidCredentials);
        return $scope.getInvalidCredentialsErrorMessage();
      case loginConstants.errorCodes.accountNotFound:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.accountNotFound);
        return languageResource.get('Response.AccountNotFound');
      case loginConstants.errorCodes.noPassword:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.noPassword);
        return languageResource.get('Response.UseSocialSignOn');
      case loginConstants.errorCodes.accountIssue:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.accountIssue);
        return languageResource.get('Response.AccountIssueErrorContactSupport');
      case loginConstants.errorCodes.tooManyAttempts:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.tooManyAttempts);
        return languageResource.get('Response.TooManyAttemptsPleaseWait');
      case loginConstants.errorCodes.defaultLoginRequired:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.defaultLoginRequired);
        const defaultLoginRequiredMessage = $scope.getDefaultLoginRequiredErrorMessage();
        $scope.handleDefaultLoginRequired(defaultLoginRequiredMessage);
        return null;
      case loginConstants.errorCodes.unverifiedCredentials:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.unverifiedAccount);
        const unverifiedCredentialsMessage = $scope.getUnverifiedCredentialsErrorMessage();
        $scope.handleDefaultLoginRequired(unverifiedCredentialsMessage);
        return null;
      case loginConstants.errorCodes.captchaLoadFailed:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.captchaLoadFailed);
        return languageResource.get('Response.CaptchaErrorFailedToLoad');
      case loginConstants.errorCodes.captchaVerifyFailed:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.captchaVerifyFailed);
        return languageResource.get('Response.CaptchaErrorFailedToVerify');
      case loginConstants.errorCodes.luoBuUserDenied:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.luoBuUserDenied);
        return languageResource.get('Response.GlobalAppAccessError');
      case loginConstants.errorCodes.captchaUnknownError:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.captchaUnknownError);
        return languageResource.get('Message.UnknownErrorTryAgain');
      case loginConstants.errorCodes.screentimeRestricted:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.screentimeRestricted);
        return languageResource.get('Description.CurfewMessage');
      default:
        incrementFailureCounter &&
          $scope.incrementEphemeralCounter(loginConstants.counters.unknownError);
        return languageResource.get('Message.UnknownErrorTryAgain');
    }
  };

  $scope.activateCaptcha = function (forceCaptcha) {
    $scope.loginLayout.forceCaptcha = forceCaptcha;
    $scope.loginLayout.isProcessing = false;
    $scope.captchaExtraValidationParams.credentialsType =
      $scope.loginFormData.enteredCredentialType;
    $scope.captchaExtraValidationParams.credentialsValue = $scope.loginFormData.credentialValue;
    $scope.captchaReturnTokenInSuccessCb = true;
    $scope.loginCaptchaActivated = true;
  };

  $scope.navigateToSecurityNotificationPage = function () {
    $window.location.href = $scope.loginFormData.securityNotificationUrl;
  };

  $scope.getInvalidCredentialsErrorMessage = function () {
    switch ($scope.loginFormData.enteredCredentialType) {
      case loginConstants.credentialTypes.email:
        return languageResource.get('Response.IncorrectEmailOrPassword');
      case loginConstants.credentialTypes.phone:
        return languageResource.get('Response.IncorrectPhoneOrPassword');
      default:
        return languageResource.get('Response.IncorrectUsernamePassword');
    }
  };

  $scope.getDefaultLoginRequiredErrorMessage = function () {
    switch ($scope.loginFormData.enteredCredentialType) {
      case loginConstants.credentialTypes.email:
        return languageResource.get('Response.EmailLinkedToMultipleAccountsLoginWithUsername');
      case loginConstants.credentialTypes.phone:
        return languageResource.get('Response.LoginWithUsername');
      default:
        return '';
    }
  };

  $scope.getUnverifiedCredentialsErrorMessage = function () {
    switch ($scope.loginFormData.enteredCredentialType) {
      case loginConstants.credentialTypes.email:
        return languageResource.get('Response.UnverifiedEmailLoginWithUsername');
      case loginConstants.credentialTypes.phone:
        return languageResource.get('Response.UnverifiedPhoneLoginWithUsername');
      default:
        return '';
    }
  };

  $scope.handleDefaultLoginRequired = function (message) {
    $scope.loginFormData.isDefaultLoginRequired = true;
    $scope.loginFormData.credentialValue = null;
    $scope.loginFormData.password = null;

    if (!message) {
      return;
    }

    systemFeedbackService.warning(message);
  };

  $scope.getRedirectUrl = function (data) {
    const returnUrlValue = $scope.loginParams.returnUrl;
    let twoStepVerificationParams;

    // tl is a two step verification ticket
    if (data && data.tl) {
      twoStepVerificationParams = {
        username: $scope.loginFormData.credentialValue,
        tl: data.tl
      };
    } else if (data && data.twoStepVerificationData) {
      twoStepVerificationParams = {
        username: data.user.name,
        tl: data.twoStepVerificationData.ticket
      };
    }

    if (twoStepVerificationParams) {
      if (returnUrlValue) {
        twoStepVerificationParams.returnUrl = returnUrlValue;
      } else if (!$scope.loginParams.redirectToHomePostLogin) {
        twoStepVerificationParams.returnUrl = $scope.getCurrentLocation();
      }

      return (
        urlService.getAbsoluteUrl(loginConstants.urls.twoStepVerification) +
        urlConstants.urlQueryStringPrefix +
        $httpParamSerializerJQLike(twoStepVerificationParams)
      );
    }
    // user without id verification
    if (data && data.identityVerificationLoginTicket) {
      localStorageService.setLocalStorage(
        'identityVerificationLoginTicket',
        data.identityVerificationLoginTicket
      );
      return urlService.getAbsoluteUrl(loginConstants.urls.koreaIdVerification);
    }

    if (data && (data.userId || (data.user && data.user.id))) {
      if (returnUrlValue) {
        const returnUrl = $scope.addNewLoginQueryStringToUrl(returnUrlValue);
        return urlService.getAbsoluteUrl(returnUrl);
      }

      if ($scope.loginParams.redirectToHomePostLogin) {
        return (
          $scope.loginFormData.homeUrl +
          urlConstants.urlQueryStringPrefix +
          $httpParamSerializerJQLike({
            nl: true
          })
        );
      }

      return $scope.getCurrentLocation();
    }

    return urlService.getAbsoluteUrl('/');
  };

  $scope.getCurrentLocation = function () {
    let currentLocation = $window.location.href;
    const hashLocation = currentLocation ? currentLocation.indexOf(urlConstants.hashSign) : -1;

    if (hashLocation > -1) {
      currentLocation = currentLocation.slice(0, -1 * (currentLocation.length - hashLocation));
    }

    return $scope.addNewLoginQueryStringToUrl(currentLocation);
  };

  $scope.addNewLoginQueryStringToUrl = function (url) {
    if (!url) {
      return '/';
    }

    let result = url;
    if (url.indexOf(urlConstants.urlQueryStringPrefix) > -1) {
      result += urlConstants.urlQueryParameterSeparator;
    } else {
      result += urlConstants.urlQueryStringPrefix;
    }

    result += loginConstants.newLoginQueryString;
    return result;
  };

  $scope.loginWithFb = function () {
    $scope.sendInteractionClickEvent(loginConstants.fbLoginButtonName);
    $window.location.href = $scope.loginFormData.redirectToFb;
  };

  $scope.sendInteractionClickEvent = function (fieldName) {
    if (FormEvents) {
      FormEvents.SendInteractionClick($scope.loginParams.context, fieldName);
    }
  };

  $scope.quickLogin = function () {
    $scope.sendInteractionClickEvent(loginConstants.quickLoginButtonName);
    CrossDeviceLoginDisplayCodeService.openModal();
  };

  $scope.launchAccountRecoveryModal = function () {
    AccountRecoveryModalService.openAccountRecoveryModal($scope.accountRecoveryLoginFailureCount);
  };

  $scope.launchSecurityQuestionsModal = async function (userId, sessionId) {
    const rendered = await SecurityQuestions.renderChallenge({
      containerId: loginConstants.securityQuestionsModalContainerId,
      userId: userId.toString(),
      sessionId,
      renderInline: false,
      shouldDynamicallyLoadTranslationResources: false,
      onChallengeCompleted: ({ redemptionToken }) => {
        $timeout(function () {
          $scope.securityQuestionParameter = {
            sessionId,
            redemptionToken
          };
          // This logic adapted from `handleCaptchaSuccess`.
          const isCrossDeviceLogin =
            $scope.loginFormData.enteredCredentialType === loginConstants.credentialTypes.authToken;
          if (isCrossDeviceLogin) {
            $scope.login(null);
          } else {
            $scope.submit(false, null);
          }
        });
      },
      onChallengeInvalidated: () => {
        $timeout(function () {
          $scope.securityQuestionParameter = null;
          $scope.login(null);
        });
      },
      onModalChallengeAbandoned: () => {
        $timeout(function () {
          $scope.loginLayout.isProcessing = false;
        });
      }
    });
    if (!rendered) {
      $scope.loginLayout.isProcessing = false;
      $scope.loginLayout.error = languageResource.get('Message.UnknownErrorTryAgain');
    }
  };

  $scope.submit = function (fireClickEvent, captchaData) {
    $scope.clearError();

    if (!$scope.loginFormData.credentialValue || !$scope.loginFormData.password) {
      if (!$scope.loginParams.redirectToLoginPageOnError) {
        $scope.loginLayout.error = languageResource.get('Message.UsernameAndPasswordRequired');
      }

      return;
    }

    if (fireClickEvent) {
      $scope.sendInteractionClickEvent(loginConstants.loginSubmitButtonName);
      $scope.incrementEphemeralCounter(loginConstants.counters.attempt);

      if ($scope.loginLayout.isFirstSubmit) {
        $scope.loginLayout.isFirstSubmit = false;
        $scope.incrementEphemeralCounter(loginConstants.counters.firstAttempt);
      }
    }

    $scope.loginLayout.isProcessing = true;
    $scope.loginFormData.enteredCredentialType = loginConstants.credentialTypes.username;

    $scope.login(captchaData);
  };

  $scope.clearError = function () {
    $scope.loginLayout.error = null;
  };

  $scope.getCredentialPlaceholder = function () {
    if ($scope.loginFormData.isDefaultLoginRequired) {
      return languageResource.get('Label.Username');
    }

    return languageResource.get('Label.UsernameEmailPhone');
  };

  $scope.isEmail = function (input) {
    return input && input.indexOf(loginConstants.atSymbol) > -1;
  };

  $scope.incrementEphemeralCounter = function (name) {
    // eslint-disable-next-line no-undef
    if (EventTracker && name) {
      // eslint-disable-next-line no-undef
      EventTracker.fireEvent(loginConstants.counters.prefix + name);
    }
  };
}

loginModule.controller('loginFormController', loginFormController);

export default loginFormController;
